import React from 'react';

import { FixedFeeNewContractStepOneData } from '../../../types';

interface UseStepOneRateProps {
  updateState: (nextValue: Partial<FixedFeeNewContractStepOneData>) => void;
}

interface UseStepOneRateResult {
  handleRateChange: (nextRate: number) => void;
}

export const useStepOneRate = ({ updateState }: UseStepOneRateProps): UseStepOneRateResult => {
  const handleRateChange = React.useCallback(
    (nextRate: number) => {
      updateState({
        rate: nextRate,
      });
    },
    [updateState]
  );

  return {
    handleRateChange,
  };
};
